// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3ycGP","item":"PaymentsMobile_item__1j0bp","label":"PaymentsMobile_label__3U3bt","amount":"PaymentsMobile_amount__RMDDI"};